import { render, staticRenderFns } from "./shieldWarningIcon.vue?vue&type=template&id=b8b7d5e0&"
import script from "./shieldWarningIcon.vue?vue&type=script&lang=js&"
export * from "./shieldWarningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports